<template>
  <div class="stacked-sharing d-grid gap-2">
    <component :is="shareButtonComponentForChannel(channel)" v-for="channel of sharing.channels" :key="channel.kind"
               :sharing-options="sharingOptionsForChannel(channel)" class="btn-light"
               :class="{'d-md-none': channel.mobileOnly}" />

    <web-share-api-button v-if="webShareSupported" :label="webShareApiButtonLabel"
                          :sharing-options="sharingOptionsForChannel({kind: 'webShareApi'})" class="btn-light" />
  </div>
</template>

<script>
import shareMixin from '@/share/campaign/share-mixin'

export default {
  mixins: [ shareMixin ]
}
</script>

<style lang="scss" scoped>
.btn-light {
  ::v-deep(.share-icon) {
    margin-right: 15px;
  }
}
</style>
